const WISHLIST_KEY = 'sareemart_wishlist';

const WishlistManager = {
  getWishlist() {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
  },

  saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    this.updateBadge();
  },

  isInWishlist(handle) {
    return this.getWishlist().some(item => item.handle == handle);
  },

  isInWishlistById(id) {
    return this.getWishlist().some(item => item.id == id);
  },

  addToWishlist(product) {
    const list = this.getWishlist();
    if (!this.isInWishlist(product.handle)) {
      list.push(product);
      this.saveWishlist(list);
      this.showToast('Added to Wishlist ❤️');
    }
  },

  removeFromWishlist(handle) {
    const list = this.getWishlist().filter(item => item.handle != handle);
    this.saveWishlist(list);
    this.showToast('Removed from Wishlist');
    this.renderWishlistPage();
    this.updateWishlistButtons();
  },

  updateBadge() {
    const count = this.getWishlist().length;
    document.querySelectorAll('.wishlist-count, .sf-wishlist-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  },

  showToast(message) {
    let toast = document.getElementById('wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wishlist-toast';
      toast.style.cssText = `
        position:fixed; bottom:24px; left:50%; transform:translateX(-50%);
        background:#2c2c2c; color:#fff; padding:12px 24px;
        border-radius:4px; font-size:14px; z-index:9999;
        opacity:0; transition:opacity 0.3s ease; pointer-events:none;
        font-family:inherit; letter-spacing:0.5px;
      `;
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.opacity = '1';
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(() => { toast.style.opacity = '0'; }, 2500);
  },

  updateWishlistButtons() {
    // Our custom buttons
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const handle = btn.dataset.productHandle || btn.dataset.productId;
      const inList = this.isInWishlist(handle);
      btn.classList.toggle('wishlisted', inList);
      const icon = btn.querySelector('.wishlist-icon');
      if (icon) icon.innerHTML = inList ? '❤️' : '🤍';
    });

    // Theme native wishlist buttons (sf-wishlist__button)
    document.querySelectorAll('.sf-wishlist__button').forEach(btn => {
      const handle = btn.dataset.productHandle;
      const inList = this.isInWishlist(handle);
      btn.classList.toggle('active', inList);
      btn.classList.toggle('sf-wishlist__button--active', inList);
    });
  },

  // Fetch product data by handle from Shopify
  async fetchProduct(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      const p = await res.json();
      return {
        handle: p.handle,
        id: p.id,
        title: p.title,
        price: p.price_min,
        priceFormatted: (p.price_min / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
        image: p.featured_image || (p.images && p.images[0]) || '',
        url: `/products/${p.handle}`
      };
    } catch(e) {
      return null;
    }
  },

  renderWishlistPage() {
    const container = document.getElementById('wishlist-page-container')
                   || document.getElementById('wishlist-products-grid');
    const emptyMsg = document.getElementById('wishlist-empty-message');
    if (!container) return;

    const list = this.getWishlist();

    if (list.length === 0) {
      container.innerHTML = '';
      if (emptyMsg) emptyMsg.style.display = 'block';
      return;
    }

    if (emptyMsg) emptyMsg.style.display = 'none';

    container.innerHTML = `
      <div class="wishlist-grid" style="display:grid; grid-template-columns:repeat(2,1fr); gap:24px; padding:20px;">
        ${list.map(item => `
          <div class="wishlist-card" style="border:1px solid #eee; border-radius:4px; overflow:hidden;">
            <a href="${item.url}">
              <img src="${item.image}" alt="${item.title}" style="width:100%; aspect-ratio:3/4; object-fit:cover; display:block;" loading="lazy">
            </a>
            <div style="padding:12px;">
              <a href="${item.url}" style="color:#2c2c2c; text-decoration:none; font-size:14px; font-weight:500; display:block; margin-bottom:6px;">${item.title}</a>
              <p style="font-size:13px; color:#666; margin-bottom:10px;">${item.priceFormatted || item.price}</p>
              <button onclick="WishlistManager.removeFromWishlist('${item.handle}')"
                style="background:none; border:1px solid #ccc; padding:6px 14px; font-size:12px; cursor:pointer; border-radius:2px; color:#666;">
                Remove
              </button>
            </div>
          </div>
        `).join('')}
      </div>`;
  },

  init() {
    const self = this;

    // Handle theme's native sf-wishlist__button clicks
    document.addEventListener('click', async function(e) {
      const btn = e.target.closest('.sf-wishlist__button');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const handle = btn.dataset.productHandle;
      if (!handle) return;

      if (self.isInWishlist(handle)) {
        self.removeFromWishlist(handle);
      } else {
        const product = await self.fetchProduct(handle);
        if (product) {
          self.addToWishlist(product);
          self.updateWishlistButtons();
        }
      }
    });

    // Handle our custom data-wishlist-btn clicks
    document.addEventListener('click', async function(e) {
      const btn = e.target.closest('[data-wishlist-btn]');
      if (!btn) return;
      e.preventDefault();
      const handle = btn.dataset.productHandle;
      if (!handle) return;

      if (self.isInWishlist(handle)) {
        self.removeFromWishlist(handle);
      } else {
        const product = await self.fetchProduct(handle);
        if (product) {
          self.addToWishlist(product);
          self.updateWishlistButtons();
        }
      }
    });

    // Responsive styles
    const style = document.createElement('style');
    style.textContent = `
      @media (min-width: 768px) { .wishlist-grid { grid-template-columns: repeat(3,1fr) !important; } }
      @media (min-width: 1024px) { .wishlist-grid { grid-template-columns: repeat(4,1fr) !important; } }
      .sf-wishlist__button.active .sf__tooltip-icon svg,
      .sf-wishlist__button.sf-wishlist__button--active .sf__tooltip-icon svg { fill: #c0392b; stroke: #c0392b; }
    `;
    document.head.appendChild(style);

    this.updateBadge();
    this.updateWishlistButtons();
    this.renderWishlistPage();
  }
};

document.addEventListener('DOMContentLoaded', () => WishlistManager.init());
